import { gql } from "@apollo/client";

export const SUBGRAPH_DETAIL_AND_PROJECT_AND_INDEXING_STATUS_QUERY = gql`
  query Subgraph($subgraphId: ID!, $projectId: ID!, $cluster: GraphCluster!) {
    subgraph(subgraphId: $subgraphId, projectId: $projectId, cluster: $cluster) {
      createdAt
      id
      identifier
      cluster
      name
      projectId
      deployUrl
    }

    project(projectId: $projectId) {
      id
      name
      secret
    }

    subgraphIndexingStatusForCurrentVersion(projectId: $projectId, subgraphId: $subgraphId, cluster: $cluster) {
      ...IndexingStatusFields
    }

    subgraphIndexingStatusForPendingVersion(projectId: $projectId, subgraphId: $subgraphId, cluster: $cluster) {
      ...IndexingStatusFields
    }
  }

  fragment IndexingStatusFields on SubgraphIndexingStatus {
    health
    node
    synced
    subgraph
    queryUrl
    chains {
      network
      latestBlock {
        number
      }
      chainHeadBlock {
        number
      }
      lastHealthyBlock {
        number
      }
      earliestBlock {
        number
      }
    }
    entityCount
    fatalError {
      block {
        hash
        number
      }
      deterministic
      handler
      message
    }
    nonFatalErrors {
      block {
        number
        hash
      }
      deterministic
      handler
      message
    }
  }
`;

export const PROJECT_AND_SUBGRAPH_QUERY = gql`
  query Project($projectId: ID!, $cluster: GraphCluster!) {
    project(projectId: $projectId) {
      id
      name
      identifier
      secret
      allowOrigins
      createdAt
    }

    subgraphs(projectId: $projectId, cluster: $cluster) {
      createdAt
      id
      identifier
      cluster
      name
      projectId
      indexingStatus {
        entityCount
        synced
        health
        chains {
          network
        }
      }
    }
  }
`;
